export default __webpack_public_path__ + "static/media/solis-case-study.2839b331.png";